/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { IntegrationProvider } from "./IntegrationProvider";
import {
  IntegrationProviderFromJSON,
  IntegrationProviderFromJSONTyped,
  IntegrationProviderToJSON,
  IntegrationProviderToJSONTyped,
} from "./IntegrationProvider";
import type { IntegrationEnvironment } from "./IntegrationEnvironment";
import {
  IntegrationEnvironmentFromJSON,
  IntegrationEnvironmentFromJSONTyped,
  IntegrationEnvironmentToJSON,
  IntegrationEnvironmentToJSONTyped,
} from "./IntegrationEnvironment";

/**
 *
 * @export
 * @interface MaskedCompanyIntegration
 */
export interface MaskedCompanyIntegration {
  /**
   *
   * @type {string}
   * @memberof MaskedCompanyIntegration
   */
  integrationId: string;
  /**
   *
   * @type {string}
   * @memberof MaskedCompanyIntegration
   */
  companyId: string;
  /**
   *
   * @type {IntegrationProvider}
   * @memberof MaskedCompanyIntegration
   */
  provider: IntegrationProvider;
  /**
   *
   * @type {string}
   * @memberof MaskedCompanyIntegration
   */
  name?: string | null;
  /**
   *
   * @type {IntegrationEnvironment}
   * @memberof MaskedCompanyIntegration
   */
  environment?: IntegrationEnvironment | null;
  /**
   *
   * @type {boolean}
   * @memberof MaskedCompanyIntegration
   */
  enabled: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof MaskedCompanyIntegration
   */
  lastSuccessfulCallAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof MaskedCompanyIntegration
   */
  lastError?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof MaskedCompanyIntegration
   */
  lastErrorAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof MaskedCompanyIntegration
   */
  createdAt: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof MaskedCompanyIntegration
   */
  updatedAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof MaskedCompanyIntegration
   */
  companyName?: string | null;
}

/**
 * Check if a given object implements the MaskedCompanyIntegration interface.
 */
export function instanceOfMaskedCompanyIntegration(
  value: object,
): value is MaskedCompanyIntegration {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("updatedAt" in value) || value["updatedAt"] === undefined) return false;
  return true;
}

export function MaskedCompanyIntegrationFromJSON(
  json: any,
): MaskedCompanyIntegration {
  return MaskedCompanyIntegrationFromJSONTyped(json, false);
}

export function MaskedCompanyIntegrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MaskedCompanyIntegration {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
    companyId: json["companyId"],
    provider: IntegrationProviderFromJSON(json["provider"]),
    name: json["name"] == null ? undefined : json["name"],
    environment:
      json["environment"] == null
        ? undefined
        : IntegrationEnvironmentFromJSON(json["environment"]),
    enabled: json["enabled"],
    lastSuccessfulCallAt:
      json["lastSuccessfulCallAt"] == null
        ? undefined
        : json["lastSuccessfulCallAt"],
    lastError: json["lastError"] == null ? undefined : json["lastError"],
    lastErrorAt: json["lastErrorAt"] == null ? undefined : json["lastErrorAt"],
    createdAt: json["createdAt"],
    updatedAt: json["updatedAt"],
    companyName: json["companyName"] == null ? undefined : json["companyName"],
  };
}

export function MaskedCompanyIntegrationToJSON(
  json: any,
): MaskedCompanyIntegration {
  return MaskedCompanyIntegrationToJSONTyped(json, false);
}

export function MaskedCompanyIntegrationToJSONTyped(
  value?: MaskedCompanyIntegration | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
    companyId: value["companyId"],
    provider: IntegrationProviderToJSON(value["provider"]),
    name: value["name"],
    environment: IntegrationEnvironmentToJSON(value["environment"]),
    enabled: value["enabled"],
    lastSuccessfulCallAt: value["lastSuccessfulCallAt"],
    lastError: value["lastError"],
    lastErrorAt: value["lastErrorAt"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
    companyName: value["companyName"],
  };
}
